module.exports = __webpack_public_path__ + "static/media/ev4.1bb56a18.jpg";